'use client';

import React, { useState } from 'react';
import { Toaster } from 'sonner';
import AuthBrandPanel from './AuthBrandPanel';
import AuthForm from './AuthForm';

export type AuthMode = 'login' | 'signup';

export default function AuthShell() {
  const [mode, setMode] = useState<AuthMode>('login');

  return (
    <div
      className="min-h-screen flex"
      style={{ background: 'hsl(222 47% 6%)' }}
    >
      <Toaster position="bottom-right" theme="dark" />
      <AuthBrandPanel />
      <div className="flex-1 flex items-center justify-center p-6 lg:p-10">
        <div className="w-full max-w-md">
          <AuthForm mode={mode} setMode={setMode} />
        </div>
      </div>
    </div>
  );
}